import { useState } from 'react';

const useGameSettings = () => {
  const [selectedCategory, setSelectedCategory] = useState(9);
  const [selectedDifficulty, setSelectedDifficulty] = useState('medium');
  const [questionCount, setQuestionCount] = useState(10);
  const [muted, setMuted] = useState(false);

  return {
    // State
    selectedCategory,
    setSelectedCategory,
    selectedDifficulty,
    setSelectedDifficulty,
    questionCount,
    setQuestionCount,
    muted,
    setMuted
  };
};

export default useGameSettings;
